import { useEffect, useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './AnalisisMeta.css';
import Cardsimple from '../../cards/Cardsimple';

const AnalisisMeta = ({ codigo }) => {
  const [analisis, setAnalisis] = useState('');
  const [textoVisible, setTextoVisible] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cod = codigo?.trim?.();
    if (!cod) {
      // Limpia el estado y no llama a la API
      setAnalisis('');
      setTextoVisible('');
      setError('');
      setLoading(false);
      return;
    }

    const fetchAnalisis = async () => {
      setLoading(true);
      setError('');
      setAnalisis('');
      setTextoVisible('');

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Sesión expirada o sin token.');
          setLoading(false);
          return;
        }
        const url = `${process.env.REACT_APP_URL_API}analisis-meta/${cod}`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data?.error) {
          setError(res.data.error);
        } else {
          setAnalisis(res.data.analisis || '');
        }
      } catch (err) {
        if (err.response?.status === 404) {
          setError('No se encontró información para este código.');
        } else {
          setError('Ocurrió un problema al generar el análisis con IA.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAnalisis();
  }, [codigo]);

  // Animación palabra por palabra **preservando formato Markdown**
  useEffect(() => {
    if (!analisis) return;

    setTextoVisible('');

    // Regex que captura palabra/no-espacio y su espacio(s) siguiente (incluye \n, \r\n, etc.)
    const regex = /(\S+)(\s*)/g;
    const tokens = [];
    let m;
    while ((m = regex.exec(analisis)) !== null) {
      tokens.push((m[1] || '') + (m[2] || ''));
    }

    // Si no hubo tokens (texto vacío o solo espacios), mostrar todo
    if (tokens.length === 0) {
      setTextoVisible(analisis);
      return;
    }

    let i = 0;
    const velocidad = 20; // ms entre palabras (ajusta aquí)
    const timer = setInterval(() => {
      setTextoVisible((prev) => prev + tokens[i]);
      i++;
      if (i >= tokens.length) clearInterval(timer);
    }, velocidad);

    return () => clearInterval(timer);
  }, [analisis]);

  return (
    <Cardsimple
      header={<h5 className="text-sm text-center my-0">🤖Análisis asistido por IA (versión Beta)</h5>}
      style={`card card-secondary shadow`}
      condensed={false}
    >
      {loading && (
        <div className='text-center py-4'>
          <div className="spinner-grow spinner-grow-sm" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="text-center">Pensando... </div>
        </div>
      )}
      {error && <div className="alert">{error}</div>}

      {!loading && !error && textoVisible !== '' && (
        <div className="">
          <div className="markdown-body">            
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {textoVisible}
            </ReactMarkdown>
          </div>
          <hr />
          <div className='text-gray small'>              
            </div>
          <hr />
          <div className="ai-header card-footer">
            <small className="ai-note"><b>🤖 Versión Beta:</b> Análisis generado automáticamente con fines informativos. Los resultados son preliminares y están sujetos a revisión y validación técnica.</small>
          </div>
        </div>

      )}
    </Cardsimple>
  );
};

export default AnalisisMeta;
